import { BookingPage } from '@in-life-and-loyalty/vaps-feature-car-maintenance'
import type { GetStaticProps } from 'next'

function Booking() {
  return <BookingPage />
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  try {
    return {
      props: {
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          showBorderRadius: true,
          showFooterBorderRadius: false,
          showFooterAppNudge: false,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch {
    return { notFound: true } as const
  }
}

export default Booking
